import {
   ArrowLeftMdIcon,
   BoltIcon,
   ChevronRightIcon,
   SknowFlakeIcon,
   Start02Icon,
   UsersIcon,
} from '@forwardflow/icons'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { IFilterCriteria } from '@forwardflow/types/onboarding'
import { Button, ContentCard, Grid, Group, Stack } from '@forwardflow/ui-v2'
import cn from 'classnames'
import FilterDefinition from './FilterDefinition'

const CAMPAIGN_TYPE_OPTIONS = [
   {
      id: 'new-lead',
      label: 'New Leads',
      description:
         'Instantly engage every new inquiry the moment it enters your CRM.',
      icon: <BoltIcon width={23} height={23} color="#9F7BFF" />,
      color: '#9F7BFF',
   },
   {
      id: 'revive',
      label: 'Cold Leads',
      description: 'Re-engage past prospects who went cold.',
      icon: <SknowFlakeIcon width={23} height={23} color="#1FB6FF" />,
      color: '#1FB6FF',
   },
   {
      id: 'both',
      label: 'Both',
      description: 'Combine new and old for full-funnel coverage.',
      icon: <UsersIcon width={23} height={23} color="#05DF72" />,
      color: '#05DF72',
   },
]

export const KindsOfLeads = ({
   setStep,
}: {
   setStep: (step: number) => void
}) => {
   const {
      setCampaignConfiguration,
      onboardingData,
      getNextStep,
      getFirstFilterCriteria,
      getRestFilterCriterias,
   } = useOnboardingStoreV2()
   const firstFilterCriteria = getFirstFilterCriteria()
   const restFilterCriterias = getRestFilterCriterias()
   return (
      <Stack>
         <ContentCard className="space-y-4 !p-0">
            <Stack className="p-6 border-b border-[#272E35]">
               <Group>
                  <Start02Icon />
                  <p className="text-white font-semibold text-lg">
                     Which leads should Forward Flow work on?
                  </p>
               </Group>
               <FilterDefinition
                  filterCriteria={firstFilterCriteria as IFilterCriteria}
               />
            </Stack>
            <Stack className="p-6 border-b border-[#272E35] py-4 pt-0">
               {restFilterCriterias.map((filterCriteria) => (
                  <FilterDefinition
                     key={filterCriteria.field}
                     filterCriteria={filterCriteria as IFilterCriteria}
                  />
               ))}
            </Stack>
            <Stack className="p-6 pt-0">
               <p className="text-white font-semibold text-lg">
                  Which type of leads should Forward Flow work on?
               </p>
               <Stack gap={16}>
                  {CAMPAIGN_TYPE_OPTIONS.map((option) => (
                     <button
                        key={option.id}
                        className={cn(
                           'rounded-[8px] bg-white/5 p-4 text-left flex items-center gap-4',
                           onboardingData?.campaignConfiguration
                              ?.campaign_type === option.id &&
                              'bg-[#A684FF1A] border border-[#A684FF]/40'
                        )}
                        onClick={() =>
                           setCampaignConfiguration({
                              campaign_type: option.id as
                                 | 'new-lead'
                                 | 'revive'
                                 | 'both',
                           })
                        }
                     >
                        <Group
                           className={`rounded-[8px] p-2`}
                           justify="center"
                           align="center"
                           style={{ backgroundColor: `${option.color}1A` }}
                        >
                           {option.icon}
                        </Group>
                        <Stack gap={2}>
                           <p className="text-white font-semibold text-lg">
                              {option.label}
                           </p>
                           <p className="text-white/70 text-xs">
                              {option.description}
                           </p>
                        </Stack>
                     </button>
                  ))}
               </Stack>
            </Stack>
         </ContentCard>
         <Grid>
            <Grid.Col span={3}>
               <Button
                  variant="secondary"
                  className="w-full"
                  onClick={() => setStep(3)}
               >
                  <ArrowLeftMdIcon width={12} /> Back
               </Button>
            </Grid.Col>
            <Grid.Col span={9}>
               <Button
                  className="w-full"
                  onClick={() => getNextStep()}
                  disabled={
                     !onboardingData?.campaignConfiguration?.campaign_type
                  }
               >
                 Save and Continue <ChevronRightIcon width={18} />
               </Button>
            </Grid.Col>
         </Grid>
      </Stack>
   )
}
